import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function MethodSection() {
  return <section className="w-full bg-ivory py-20 md:py-28" aria-labelledby="metodo" data-id="element-153" data-mp="7sk17lp7q5jh">
      <div className="mx-auto max-w-4xl px-6 lg:px-8" data-id="element-154" data-mp="2va0vb0ac9gv">
        <SectionHeading eyebrow="El método" title={<span id="metodo" data-id="element-156" data-mp="3uz2tp54tx05g">Aquí empieza tu regreso.</span>} data-id="element-155" data-mp="2w1vojm26363" />

        <Reveal delay={0.08} className="mt-12" data-id="element-157" data-mp="viwelc388uhg">
          <div className="mx-auto max-w-2xl rounded-[1.75rem] border border-sand bg-shell/60 px-8 py-12 text-center sm:px-12" data-id="element-158" data-mp="vhl12kjzc8d5">
            <p className="font-display text-[1.75rem] font-light leading-tight text-ink sm:text-[2.1rem]" data-id="element-159" data-mp="qlw8j16dnrqc">
              La mujer que olvidaste ser
              <span className="align-super font-sans text-[0.6rem] text-warmgray" data-id="element-160" data-mp="hsavbm9v2ij1">™</span>
            </p>
            <span aria-hidden="true" className="mx-auto mt-6 block h-[1px] w-12 bg-goldsoft" data-id="element-161" data-mp="1e9nnydn7skvu" />
            <p className="mt-6 font-sans text-[0.68rem] uppercase tracking-luxe text-gold" data-id="element-162" data-mp="19if9h37129bt">
              El método de 7 días para volver a ti
            </p>
          </div>
        </Reveal>

        <div className="mx-auto mt-12 max-w-reading space-y-5 text-center font-sans text-[1rem] font-light leading-[1.9] text-warmgray" data-id="element-163" data-mp="201v72kwok8tl">
          <Reveal delay={0.05} data-id="element-164" data-mp="1lbwbmpwifbht">
            <p data-id="element-165" data-mp="1lal5wkji7to2">
              Una experiencia guiada diseñada para ayudarte a reconectar con tu identidad,
              recuperar claridad emocional y volver a elegirte.
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-166" data-mp="1hauce92lezfu">
            <p className="font-display text-2xl italic text-ink" data-id="element-167" data-mp="1hb3znow96shu">
              No es teoría. No es motivación vacía.
            </p>
          </Reveal>
          <Reveal delay={0.15} data-id="element-168" data-mp="12fxv76ct31qm">
            <p data-id="element-169" data-mp="17c4skar4z4wy">Es un proceso práctico con ejercicios, reflexión y pequeñas acciones.</p>
          </Reveal>
        </div>
      </div>
    </section>;
}